import { render, staticRenderFns } from "./IconMoonStarSolid.vue?vue&type=template&id=5434a3fe&"
import script from "./IconMoonStarSolid.vue?vue&type=script&lang=js&"
export * from "./IconMoonStarSolid.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports